// extracted by mini-css-extract-plugin
export const main = "feedback-module--main--bcGb-";
export const group = "feedback-module--group--2FTlC";
export const feedback = "feedback-module--feedback--2QaFw";
export const submitting = "feedback-module--submitting--2c9pL";
export const container = "feedback-module--container--37OJI";
export const info = "feedback-module--info--NYhXq";